import React from "react";
import { unitConverters } from "./ConstantsUnitConverter";
import SharedHelmet from ".././Helmet";
const TITLE =
  "حواسب محولات وحدات القياس - حواسب مجانية لحساب تحويلات وحدات الزمن والطول والحرارة والمساحة والحجم و الزمن.";
  const DESCRIPTION =
  "استكشف مجموعة حواسب محولات وحدات القياس المجانية لدينا، بما في ذلك حواسب الطول، الوزن، الحجم، الوقت وغيرها من وحدات القياس المختلفة. تحويل سريع ودقيق.";
  const KEYWORDS =
  "حاسبة وحدة قياس الطول، حاسبة وحدة قياس الوزن، حاسبة وحدة قياس الحرارة، حاسبة وحدة قياس المساحة، حاسبة وحدة قياس الحجم، حاسبة وحدة قياس الزمن";
const OG_URL = "https://do-calculate.com/ar/unit_converter/";
function UnitList() {
  return (
    <div className="container rtl-container">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table >
        <thead>
          <tr>
            <th >الحاسبة</th>
            <th >الوصف</th>
          </tr>
        </thead>
        <tbody>
          {unitConverters.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default UnitList;
